export const selectFilterHelper = (input, option) => {
  if (!input?.length) return true;
  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
